// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"c3ba77ae","163":"3cfcf5ad","419":"586393e7","563":"72e787d9","787":"b4132632","942":"97fcc29e"}[chunkId] + ".chunk.js";
};